import { RxJsonSchema, toTypedRxJsonSchema, ExtractDocumentTypeFromTypedRxJsonSchema } from 'rxdb';

export const CLU_TICKREGLEMENT_SCHEMA_LITERAL = {
    title: 'Schéma ReglementTicket',
    description: 'Ticket',
    version: 7,
    keyCompression: false,
    primaryKey: 'PK_ID',
    type: 'object',
    properties: {
        MD_DOGID : { type : 'string' },
        PK_ID : { type : 'string', maxLength : 100 },
        MD_SITEGID : { type : 'string' },
        MD_SITE : { type : 'string' },
        MD_CAISSE : { type : 'string' },
        MD_CAISSIERGID : { type : 'string' },
        MD_CAISSIER : { type : 'string' },
        MD_CAISSE_SESSION : { type : 'string' },
        MD_LOCALGID : { type : 'string' },
        MD_DATE_CREATION : { type : 'string' },
        MD_CBMARQ : { type : 'number' },
        RG_NO_INTERNAL : { type : 'number' },
        DO_PIECE : { type : 'string' },
        DO_PIECE_INTERNAL : { type : 'string' },
        RG_DATE : { type : 'string' },
        N_REGLEMENT_MODE : { type : 'string', default : 0 },
        N_REGLEMENT : { type : 'string' },
        N_REGLEMENTLIB : { type : 'string' },
        RG_MONTANT : { type : 'number', default : 0 },
        RG_PROV : { type : 'number', default : 0 },
        N_DEVISE_ENABLE : { type : 'boolean' },
        N_DEVISE : { type : 'number', default : 0 },
        N_DEVISE_LIB : { type : ['string', 'null'] },
        RG_MONTANTDEV : { type : 'number', default : 0 },
        RG_COURS : { type : 'number', default : 0 },
        RG_REFERENCE : { type : ['string', 'null'] },
        RG_ECART : { type : ['number', 'null'] },
        JO_NUMECART : { type : ['string', 'null'] },
        CG_NUMECART : { type : ['string', 'null'] },
        RG_MONTANTECART : { type : ['number', 'null'] },
        RG_MONTANTECART_F : { type : ['number', 'null'] },
        RG_ESP_RECU : { type : ['number', 'null'] },
        RG_ESP_RENDU : { type : ['number', 'null'] },
        RG_MONTANT_F : { type : ['number', 'null'] }
    },
    required: [ 'RG_NO_INTERNAL', 'RG_DATE', 'MD_CBMARQ', 'RG_MONTANT' ]
} as const;

const schemaTyped = toTypedRxJsonSchema(CLU_TICKREGLEMENT_SCHEMA_LITERAL);
export type RxCluTickReglementDocumentType = ExtractDocumentTypeFromTypedRxJsonSchema<typeof schemaTyped>;

export const CLU_TICKREGLEMENT_SCHEMA: RxJsonSchema<RxCluTickReglementDocumentType> = CLU_TICKREGLEMENT_SCHEMA_LITERAL;
